import { render, staticRenderFns } from "./EbookViewer.vue?vue&type=template&id=0b040d4a&scoped=true&"
import script from "./EbookViewer.vue?vue&type=script&lang=js&"
export * from "./EbookViewer.vue?vue&type=script&lang=js&"
import style0 from "./EbookViewer.vue?vue&type=style&index=0&id=0b040d4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b040d4a",
  null
  
)

export default component.exports